import { LatLngExpression } from "leaflet";
import { useState } from "react";
import { ICoordsMapProps } from "./CoordsMap.props";

interface ICoordsMapControl {
  readonly c: LatLngExpression;
  readonly city?: string;

  setC(c: LatLngExpression): void;
  setCity(s: string): void;
  onSave(): void;
}

export const useCoordsMapControl = ({
  coords = [55.982737038407954, 92.91122818482344],
  getCoords,
  setOpenMapModal,
}: Omit<ICoordsMapProps, "className">): ICoordsMapControl => {
  const [c, setC] = useState<LatLngExpression>(coords);
  const [city, setCity] = useState<string>();

  const onSave = () => {
    getCoords(c);
    setOpenMapModal(false);
  };
  return {
    c,
    city,

    setC,
    setCity,
    onSave,
  };
};
